import * as Factory from 'factory.ts'
import faker from 'faker'

import { type PayRequest } from '@webapp/models/PayRequest'
import { AccountMock } from './account.factory'
import { CurrencyMock } from './currency.factory'
import { DepartmentMock } from './department.factory'
import { PayCardMock } from './payCard.factory'
import { PayCardholderMock } from './payCardholder.factory'
import { SimpleUserMock } from './user.factory'

export const PayRequestMock = Factory.Sync.makeFactory<PayRequest>({
  id: Factory.each(() => faker.random.number()),
  account: AccountMock.build(),
  amount: Factory.each(() => faker.random.number().toString()),
  currency: CurrencyMock.build({
    name: 'USD',
  }),
  card: PayCardMock.build(),
  cardholder: PayCardholderMock.build(),
  date_created: Factory.each(() => faker.date.past(10).toISOString()),
  department: DepartmentMock.build(),
  reason: Factory.each(() => faker.lorem.sentence()),
  next_approver: SimpleUserMock.build(),
  status: 1,
  uuid: Factory.each(() => faker.random.uuid()),
  logs: [],
  attachments: [],
  comment_object_id: Factory.each(() => faker.random.number()),
  title: Factory.each(() => faker.lorem.sentence()),
  fund: null,
  is_virtual_card_request: false,
})
